import styled from '@emotion/styled';
import { FilterPopupContainer } from 'components/filters/styled/dropdown';


export const FilterContainer = styled(FilterPopupContainer)`
  position: absolute;
  top: 0;
  right: 0;
  max-width: 300px;
  z-index: 1;
`;
export const PricesSummaryFiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: 0 0 ${({ theme }) => theme.spacing(3)};
  margin-top: -${({ theme }) => theme.spacing(1)};
  position: relative;
  z-index: 2;
`;

export const CountWrapper = styled.span`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;
export const PricesMobileFilterWrapper = styled.div``;
export const PricesSummaryFilterWrapper = styled.div`
  position: relative;
`;

export const IconWrapper = styled.div`
  margin-left: ${({ theme }) => theme.spacing(1)};
  line-height: 0;
`;
